export enum DeviceSetupStatus {
  'Active' = 1,
  'Complete' = 2, // No longer used
  'Inactive' = 3,
  'Awaiting' = 4,
  'FlasksInserted' = 5,
  'ExperimentCancelled' = 6, // No longer used
  'AwaitingCalibration' = 7, // No longer used
  'CalibrationFlaskInserted' = 8, // No longer used
  'ActiveODCalibration' = 9,
  'Paused' = 10,
  'Offline' = 11, // No longer used (tracked in a seperate device variable)
  'ActiveOxygenCalibration' = 12,
  'ActivePHCalibration' = 13,
  'ActiveSpargingCalibration' = 14,
}

export const DeviceSetupStatusDisplay: Record<DeviceSetupStatus, string> = {
  [DeviceSetupStatus.Active]: 'Active',
  [DeviceSetupStatus.Complete]: 'Complete',
  [DeviceSetupStatus.Inactive]: 'Inactive',
  [DeviceSetupStatus.Awaiting]: 'Awaiting',
  [DeviceSetupStatus.FlasksInserted]: 'Flasks Inserted',
  [DeviceSetupStatus.ExperimentCancelled]: 'Experiment Cancelled',
  [DeviceSetupStatus.AwaitingCalibration]: 'Awaiting Calibration',
  [DeviceSetupStatus.CalibrationFlaskInserted]: 'Calibration Flask Inserted',
  [DeviceSetupStatus.ActiveODCalibration]: 'Active OD Calibration',
  [DeviceSetupStatus.Paused]: 'Paused',
  [DeviceSetupStatus.Offline]: 'Offline',
  [DeviceSetupStatus.ActiveOxygenCalibration]: 'Active Oxygen Calibration',
  [DeviceSetupStatus.ActivePHCalibration]: 'Active pH Calibration',
  [DeviceSetupStatus.ActiveSpargingCalibration]: 'Active Sparging Calibration',
};
